import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import {
    localize,
} from 'wanderu-i18n';
import { carrierMap } from 'wanderu-utils';

import baseAppConfig from 'wanderu-shellapp/src/config/baseApp.locales';

import DropdownMenu from './DropdownMenu/DropdownMenu';
import Submenu from './Submenu/Submenu';
import Events from './events/SiteMenuEvents';

import styles from './SiteMenu.scss';

const BUS_URL = '/bus-tickets/';
const TRAIN_URL = '/train-tickets/';
const CARRIER_URL = '/carrier/';

const propTypes = {
    className: PropTypes.string,
    isExternal: PropTypes.bool,
    isLandingPage: PropTypes.bool,
    locale: PropTypes.string,
    onCloseMenu: PropTypes.func,
    path: PropTypes.string,
    rootUrl: PropTypes.string,
    t: PropTypes.func,
    vertical: PropTypes.bool,
};

function SiteMenu(props) {
    const {
        className = '',
        isExternal = false,
        isLandingPage = false,
        locale,
        onCloseMenu = () => undefined,
        path = '',
        rootUrl = '',
        t,
        vertical = false,
    } = props;

    const selectLink = (label, closeMenu) => (e) => {
        if (closeMenu) {
            onCloseMenu(e);
        }

        Events.buttonClicked({
            label,
            navType: vertical
                ? 'hamburger'
                : 'nav_type',
        });
    };

    const linkClass = classNames(styles.link, { [styles.vertical]: vertical });
    const baseUrl = isExternal
        ? 'https://www.wanderu.com'
        : '';
    const linkTarget = isExternal
        ? '_blank'
        : undefined;

    const busOptions = carrierMap.seoBus[locale];
    const trainOptions = carrierMap.seoTrain[locale];
    const carrierOptions = carrierMap.carrierDropDown[locale];

    return (
        <nav className={classNames(styles.container, className)}>
            {vertical
                ? (
                    <>
                        <span className={styles.browse}>
                            {t('browse')}
                        </span>
                        <Submenu
                            href={path + BUS_URL}
                            linkKey="linkflow-c2c-bus"
                            locale={locale}
                            onClick={selectLink('buses', true)}
                            options={busOptions}
                            title={t.plural('bus', 2)}
                            native
                        />
                        <Submenu
                            href={path + TRAIN_URL}
                            linkKey="linkflow-c2c-train"
                            locale={locale}
                            onClick={selectLink('trains', true)}
                            options={trainOptions}
                            title={t.plural('train', 2)}
                            native
                        />
                    </>
                )
                : (
                    <>
                        <DropdownMenu
                            className={linkClass}
                            href={BUS_URL}
                            isExternal={isExternal}
                            linkKey="linkflow-c2c-bus"
                            locale={locale}
                            onClick={selectLink('buses', true)}
                            options={busOptions}
                            path={path}
                            rootUrl={rootUrl}
                            title={t.plural('bus', 2)}
                            native
                        />
                        <DropdownMenu
                            className={linkClass}
                            href={TRAIN_URL}
                            isExternal={isExternal}
                            linkKey="linkflow-c2c-train"
                            locale={locale}
                            onClick={selectLink('trains', true)}
                            options={trainOptions}
                            path={path}
                            rootUrl={rootUrl}
                            title={t.plural('train', 2)}
                            native
                        />
                    </>
                )}
            {vertical
                ? (
                    <Submenu
                        href={path + CARRIER_URL}
                        locale={locale}
                        onClick={selectLink('carriers', true)}
                        options={carrierOptions}
                        title={t('menuCarrier')}
                    />
                )
                : (
                    <DropdownMenu
                        className={linkClass}
                        href={CARRIER_URL}
                        isExternal={isExternal}
                        onClick={selectLink('carriers', true)}
                        options={carrierOptions}
                        path={path}
                        rootUrl={rootUrl}
                        title={t('menuCarrier')}
                    />
                )}
            {!isLandingPage && (
                <A
                    className={linkClass}
                    href={`${baseUrl}/explore/`}
                    onClick={selectLink('explore', true)}
                    target={linkTarget}
                    underline="none"
                    native
                >
                    {t('explore')}
                </A>
            )}
            <A
                className={linkClass}
                href={`${baseUrl}/blog/`}
                onClick={selectLink('blog', true)}
                prependLocale={false}
                target={linkTarget}
                underline="none"
                native
            >
                {t('blog')}
            </A>
        </nav>
    );
}

SiteMenu.propTypes = propTypes;

export { SiteMenu };
export default localize(SiteMenu, ['t'], baseAppConfig.namespace);
